import type { QueryClient } from '@tanstack/react-query';
import type { ScoutingPageRow } from '@/marketing/models/campaignScouting';
import { SCOUTING_KEYS } from '@/marketing/infrastructure/influencer/campaign/scouting/queries';
import { CAMPAIGN_PIPELINE_KEYS } from '@/marketing/infrastructure/influencer/campaign/pipeline/utils/keys';
import { CAMPAIGN_ACTIVITY_KEYS } from '@/marketing/infrastructure/influencer/campaign/activity/utils/keys';

/** Patch every cached occurrence without moving rows or changing captured selection revisions. */
export function patchScoutingRow(
  client: QueryClient,
  campaignId: string,
  influencerId: string,
  update: (row: ScoutingPageRow) => ScoutingPageRow,
) {
  client.setQueriesData<{ rows: ScoutingPageRow[] }>({ queryKey: SCOUTING_KEYS.pages(campaignId) }, (data) =>
    data ? { ...data, rows: data.rows.map((row) => (row.influencerId === influencerId ? update(row) : row)) } : data,
  );
}
export function markRelatedScoutingDataStale(client: QueryClient) {
  void client.invalidateQueries({ queryKey: CAMPAIGN_PIPELINE_KEYS.all, refetchType: 'none' });
  void client.invalidateQueries({ queryKey: CAMPAIGN_ACTIVITY_KEYS.all, refetchType: 'none' });
}
export function refreshActiveScoutingPage(client: QueryClient, campaignId: string) {
  return client.invalidateQueries({ queryKey: SCOUTING_KEYS.list(campaignId), refetchType: 'active' });
}
